var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomatizaIconNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04167 6.33333C5.30732 6.33333 6.33333 5.30732 6.33333 4.04167C6.33333 2.77602 5.30732 1.75 4.04167 1.75C2.77602 1.75 1.75 2.77602 1.75 4.04167C1.75 5.30732 2.77602 6.33333 4.04167 6.33333ZM4.04167 6.33333V13.6667M4.04167 13.6667C2.77602 13.6667 1.75 14.6927 1.75 15.9583C1.75 17.224 2.77602 18.25 4.04167 18.25C5.30732 18.25 6.33333 17.224 6.33333 15.9583C6.33333 14.6927 5.30732 13.6667 4.04167 13.6667ZM15.9583 13.6667V6.975C15.9583 5.94824 15.9583 5.43485 15.7585 5.04269C15.5828 4.69772 15.3023 4.41725 14.9573 4.24149C14.5652 4.04167 14.0518 4.04167 13.025 4.04167H10M15.9583 13.6667C17.224 13.6667 18.25 14.6927 18.25 15.9583C18.25 17.224 17.224 18.25 15.9583 18.25C14.6927 18.25 13.6667 17.224 13.6667 15.9583C13.6667 14.6927 14.6927 13.6667 15.9583 13.6667ZM10 4.04167L12.2917 6.33333M10 4.04167L12.2917 1.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatizaIconNew);
export default __webpack_public_path__ + "static/media/automatizaIconNew.bb8fb44297051d6a102d5588667ed963.svg";
export { ForwardRef as ReactComponent };